import {Persist, standaloneGqlFetch} from "@repo/data-gql";
import {RequestInfo} from "@repo/shared-core";

import {UNTRANSLATED_CONTENT_QUERY} from "#content-library/queries.ts";

// This checks if the content exists in English, regardless of the user's
// selected locale. It is intended to be used to display a message offering
// a link to the English version of the content if it does not exist in the
// selected locale. This is helpful because a user who has set their locale
// to something other than English can be redirected from a valid link on
// www to an invalid link on their language's subdomain.
export default async function checkContentExistsInEnglish(
    path: string,
): Promise<boolean> {
    // TODO(somewhatabstract):
    // We really should get gqlFetch from the React tree, but that just isn't how
    // this works right now, so let's use our standalone approach.
    // eslint-disable-next-line no-restricted-syntax
    const data = await standaloneGqlFetch(UNTRANSLATED_CONTENT_QUERY, {
        variables: {
            path: path.startsWith("/") ? path.substring(1) : path,
            countryCode: RequestInfo.remoteCountry,
        },
        context: {
            fastlyCaching: Persist.UntilPublish,
            targetLocale: "en",
        },
    });

    return !!data.contentRoute?.resolvedPath;
}
